






















































































import { Component, Vue } from "vue-property-decorator";
import QSignature from "@/common/qSignature.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import MovingSignature from "@/components/contract-moving/movingSignature.vue";

@Component({
  name: "StepSignature",
  components: {
    StepCheckList,
    QSignature,
    MovingSignature,
  },
})
export default class StepSignature extends Vue {}
